import { METHOD } from '../utils';

export const getPresignedS3UrlUpload = ({ fileKey, headers, }) => {
  let url = 'v1/tools/s3/presigned';
  if (headers['content-type']) {
    const filePrincipalType = headers['content-type'].split('/')[0];
    url += `/${filePrincipalType}`;
  }
  return {
    method: METHOD.PUT,
    path: url,
    content: {
      file: fileKey,
      headers,
    },
  };
};

export const getPresignedS3UrlMultipartUpload = ({
  fileKey,
  headers,
  parts = 1,
  uploadId = null,
  company,
  fileFolder,
  tags,
}) => ({
  method: METHOD.POST,
  path: 'v1/tools/s3/presigned/multipart',
  content: {
    uploadId,
    file: fileKey,
    headers,
    parts,
    tags,
    company,
    type: fileFolder,
  },
});

export const getPresignedS3UrlDownload = ({ file, }) => ({
  method: METHOD.GET,
  path: 'v1/tools/s3/presigned',
  params: {
    file: file,
  },
});

export const getAnalysis = ({
  fileId,
  analysisId,
  provider = 'velmeni',
}) => ({
  method: METHOD.GET,
  path: `/v2/tools/files/${fileId}/ia/${provider}/analysis/${analysisId}`,
});

export const getAnalysisReport = ({
  fileId,
  provider,
  analysisId,
  encode = 'Y',
  link = 'N',
  pdf = 'Y',
  html = 'N',
}) => ({
  method: METHOD.GET,
  path: `/v2/tools/files/${fileId}/ia/${provider}/analysis/${analysisId}/report`,
  params: {
    encode,
    link,
    pdf,
    html,
  },
});
